import { useCaravanDataContext } from "../CaravanDataContext";
import { DEFAULT_FIRST_FORM_VALUE, useFilterStore } from "../stores/FilterStore";
import { CountyData, LocationData } from "../types";
import { useFilterData } from "./useFilterData";

export const useGetFilteredData = () => {
  const { data } = useCaravanDataContext();
  const { county } = useFilterStore(["county"]);
  const { filterData } = useFilterData();

  // Edge-case: If for some reason we get here without picking a county then return 0 data
  // otherwise the site will crash
  if (data.length === 0 || county === DEFAULT_FIRST_FORM_VALUE) {
    return { filteredCountyData: [], noMatchesCountyData: [], totalCaravans: 0 };
  }

  // The following code applies the filters to the main data object

  const correctCounty = data?.find(
    (count) => Object.keys(count)?.[0]?.toLowerCase() === county?.toLowerCase()
  ) as CountyData;

  const countyData = Object.values(correctCounty)?.[0];

  const filteredCountyData: LocationData[] = [];
  const noMatchesCountyData: LocationData[] = [];

  countyData?.forEach((county) => {
    for (const location in county) {
      const filteredProperties = filterData(county[location]);

      if (filteredProperties.length > 0) {
        filteredCountyData.push({ [location]: filteredProperties });
      } else {
        noMatchesCountyData.push({ [location]: county[location] });
      }
    }
  });

  const totalCaravans = filteredCountyData?.reduce((total: number, obj) => {
    const key = Object.keys(obj)[0];
    const arrayLength = obj[key].length;
    return total + arrayLength;
  }, 0);

  return { filteredCountyData, noMatchesCountyData, totalCaravans };
};
